import { SubscriptionTransactionsList } from './SubscriptionTransactionsList';

export default {
    list: SubscriptionTransactionsList,
};